export const permitKeys = {
  UNDER_APPROVAL_PERMIT: 1, // На согласовании
  ALLOWED_PERMIT: 2, // Разрешен
  PROHIBITED_PERMIT: 3, // Запрещен
  EXPIRED_PERMIT: 4, // Истек
  CANCELLED_PERMIT: 5, // Аннулирован
};

export const permitValuesForChanged = {
  [permitKeys.UNDER_APPROVAL_PERMIT]: [
    permitKeys.ALLOWED_PERMIT,
    permitKeys.PROHIBITED_PERMIT,
    permitKeys.CANCELLED_PERMIT,
    permitKeys.UNDER_APPROVAL_PERMIT,
  ],
};
